import { useAuthorizationLogic } from '../container/screen/Auth/logic/useAuthorization.logic';

export const useAppInitiate = () => {
  const { isUserAuthenticated, isLoading, accountLoadFailed, roleLoadFailed, retryLoad, setupMarker } = useAuthorizationLogic();

  return {
    error: false,
    isUserAuthenticated,
    isLoading,
    loadFailed: accountLoadFailed || roleLoadFailed,
    retryLoad,
    setupMarker,
  };
};
